import React from 'react';

/**
 * PiPlayBigStroke icon from the stroke style in media category.
 */
interface PiPlayBigStrokeProps extends React.SVGProps<SVGSVGElement> {
	size?: number;
	color?: string;
	className?: string;
	ariaLabel?: string;
}

export default function PiPlayBigStroke({
	size = 24,
	color,
	className,
	ariaLabel = 'play-big icon',
	...props
}: PiPlayBigStrokeProps): JSX.Element {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			style={{ color: color || 'currentColor' }}
			role="img"
			aria-label={ariaLabel}
			{...props}
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M6 12V8.42c0-2.094 0-3.14.439-3.726a2.2 2.2 0 0 1 1.602-.876c.73-.05 1.613.516 3.38 1.65l4.027 2.583c1.533.983 2.3 1.475 2.564 2.101a2.2 2.2 0 0 1 0 1.696c-.264.626-1.031 1.118-2.564 2.101l-4.027 2.583c-1.767 1.134-2.65 1.7-3.38 1.65a2.2 2.2 0 0 1-1.602-.876C6 16.72 6 15.674 6 13.58z"
				fill="none"
			/>
		</svg>
	);
}
